export default {
  'releaseBankEntry.list.header.companies': 'Empresa',
  'releaseBankEntry.list.header.code': 'Código',
  'releaseBankEntry.list.header.description': 'Descrição',
  'releaseBankEntry.list.header.document': 'Documento',
  'releaseBankEntry.list.header.releaseDate': 'Dt. Lanc.',
  'releaseBankEntry.list.header.value': 'Valor',
  'releaseBankEntry.list.header.account': 'Conta',
  'releaseBankEntry.list.header.destination': 'Natureza',
  'releaseBankEntry.domain.enums.nature_type.revenue': 'Receita',
  'releaseBankEntry.domain.enums.nature_type.expense': 'Despesa',
  'releaseBankEntry.list.header.actions': 'Ações',

  'releaseBankEntry.create': 'Criar Novo Lançamento Bancário',
  'releaseBankEntry.searchBar.cashMovement': 'Movimento de Caixa',

  'releaseBankEntry.form.company': 'Empresa',
  'releaseBankEntry.form.description': 'Descrição',
  'releaseBankEntry.form.documentNumber': 'Número do documento',
  'releaseBankEntry.form.bankAccount': 'Conta Bancária',
  'releaseBankEntry.form.documentType': 'Tipo de Documento',
  'releaseBankEntry.form.planAccount': 'Plano de Contas',
  'releaseBankEntry.form.destination': 'Natureza',
  'releaseBankEntry.form.transfer': 'Transferência',
  'releaseBankEntry.form.installmentCode': 'Código da Parcela',
  'releaseBankEntry.form.LaunchCode': 'Código do Lançamento',
  'releaseBankEntry.form.releaseDate': 'Dt. Lançamento',
  'releaseBankEntry.form.conciliationDate': 'Dt. Conciliação',
  'releaseBankEntry.form.value': '(R$) Valor',

  'releaseBankEntry.create.notification.success': 'Sucesso!',
  'releaseBankEntry.create.notification.successDescription':
    'Lançamento bancário adicionado com sucesso!',

  'releaseBankEntry.update.notification.success': 'Sucesso!',
  'releaseBankEntry.update.notification.successDescription':
    'Lançamento bancário alterado com sucesso!',
};
